import React, {useState} from 'react';
import './App.css';
import { Route, Switch } from 'react-router-dom';
import Navigation from './components/Navigation';
import About from './components/About';
import Home from './components/Home';

import SimpleForm from './components/chatbot/SimpleForm';
import { Avatar } from '@material-ui/core';

function App() {

  const [open, setOpen] = useState(false);

  return (
    <div className="App ">

      <Navigation />
      <Switch>
        <Route exact={true} path="/" component={Home} />
        <Route path="/About" component={About} />

      </Switch>

      <div
        className="chatbot"
      >
        <Avatar
          className="chatbot-avatar"
          onClick={() => setOpen(!open)}
          src="https://media.istockphoto.com/vectors/pineapple-with-sunglases-and-headphones-summer-consept-vector-vector-id696228294"
        />
          {open && <SimpleForm />}
      </div>

    </div>
  );
}

export default App;
